import React from "react";
import { Link, useLocation } from "react-router-dom";
import classes from "./NavBar.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGrip, faPersonWalkingLuggage, faRectangleList, faNewspaper, faUser, faGears } from "@fortawesome/free-solid-svg-icons";

const mainModules = {
  apply: { name: "Apply", icon: faRectangleList },
  holiday: { name: "Gazetted Holiday", icon: faPersonWalkingLuggage },
  history: { name: "History", icon: faNewspaper },
  users: { name: "Users", icon: faUser },
  master: { name: "Master Setup", icon: faGears }
};

const subPages = {
  Leave: "Leave",
  Allowance: "Allowance",
  Expenses: "Expenses",
  LeaveHistory: "Leave History",
  AllowanceHistory: "Allowance History",
  ExpensesHistory: "Expenses History",
  profile: "Profile",
  employee: "Employee",
  role: "Role",
	permission: "Permissions",
  policy: "System Policy",
  entitlements: "Entitlements",
  allowancerate: "Allowance Rate",
};

const subToMainMap = {
  Leave: "apply",
  Allowance: "apply",
  Expenses: "apply",
  LeaveHistory: "history",
  AllowanceHistory: "history",
  ExpensesHistory: "history",
  employee: "users",
  role: "users",
  permission: "users",
  policy: "master",
  entitlements: "master",
  allowancerate: "master",
};

export default function NavInfoBar() {
  const location = useLocation();
  const segments = location.pathname.split("/").filter(Boolean);

	if (segments.length === 1 && segments[0] === "dashboard") {
    return (
      <nav className={classes.breadcrumb}>
        <Link to="/dashboard" className={classes.breadcrumbLink}>
          <FontAwesomeIcon icon={faGrip} className={classes.icon} />
        </Link>
      </nav>
    );
  }

  const enrichedSegments = [...segments];
  const firstSeg = segments[0];

  if (subToMainMap[firstSeg]) {
    enrichedSegments.unshift(subToMainMap[firstSeg]);
  }

  return (
    <nav className={classes.breadcrumb}>
      <Link to="/dashboard" className={classes.breadcrumbLink}>
        <FontAwesomeIcon icon={faGrip} className={classes.icon} />
      </Link>

      {enrichedSegments.map((seg, index) => {
        if (seg === "Dashboard") return null;

        const isMain = mainModules[seg] && (
          index === 0 || subToMainMap[segments[0]] === seg
        );

        const icon = isMain ? mainModules[seg].icon : null;
        const name = isMain
          ? mainModules[seg].name
          : subPages[seg] || seg.charAt(0).toUpperCase() + seg.slice(1);

        return (
          <span key={index} className={classes.breadcrumbItem}>
            <span className={classes.separator}> &gt; </span>
            <span className={classes.breadcrumbText}>
              {icon && (
                <FontAwesomeIcon icon={icon} className={classes.icon} />
              )}
              <span>{name}</span>
            </span>
          </span>
        );
      })}
    </nav>
  );
}